import React from "react";

export function Card({ children, className }) {
  return (
    <div className={`rounded-2xl bg-white p-6 shadow-md ${className}`}>
      {children}
    </div>
  );
}
